const actions = {
    GET_Api_DATA: "GET_Api_DATA",
    GET_Api_DATA_LOAD: "GET_Api_DATA_LOAD",
    VIDEO_DOWNLOADER:"VIDEO_DOWNLOADER",
    GET_Api_DATA_ERROR:"GET_Api_DATA_ERROR",
    CHANGE_THEME:"CHANGE_THEME"

}
export default actions